import { Metric } from '../../constants/Types';
import GetMetric from './GetMetric';

const GetSensorData = async (range, deviceNumId?: string) => {
  const metrics: string[] = [
    Metric.AQI,
    Metric.CO2,
    Metric.LIGHT,
    Metric.NOISE,
    Metric.PM25,
    Metric.TVOC,
    Metric.TEMPERATURE,
    Metric.HUMIDITY,
  ];
  const data: any = { timestamp: null };
  await Promise.all(metrics.map(async (metric: string) => {
    const result = await GetMetric({ metric, range, deviceNumId });
    data[metric] = result?.length > 0 ? result[result.length - 1]?.value ?? 0 : 0;
    data.timestamp = result?.length > 0 ? result[result.length - 1]?.timestamp : data.timestamp;
  }));
  return data;
};

export default GetSensorData;
